var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(false)?_c('button',{staticClass:"btn",on:{"click":_vm.exportBudget}},[_c('i',{staticClass:"fas fa-file-export"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }